module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp3_8023.d92dc9c2.png";